module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button-loader"
  }, [_c('div', {
    staticClass: "button-loader__container"
  }, [_c('div', {
    staticClass: "button-loader__items"
  }), _c('div', {
    staticClass: "button-loader__items"
  }), _c('div', {
    staticClass: "button-loader__items"
  }), _c('div', {
    staticClass: "button-loader__items"
  }), _c('div', {
    staticClass: "button-loader__items"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abdfb7b8","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/button/components/loader/ButtonLoader.vue
// module id = b85bb786fb2202fce614
// module chunks = 89